if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector('.js-results-container');
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector('.js-message-error');
      this.errorMessageText = this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;

      this.input.addEventListener('input', () => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.onChange(), 300);
      });

      this.btnClearText.addEventListener('click', () => this.close());
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) {
        this.close();
        return;
      }
      this.getSearchResults(searchTerm);
    }

    async getSearchResults(searchTerm) {
      this.isOpen = true;
      try {
        const response = await fetch(`${Shopify.routes.root}search?q=${encodeURIComponent(searchTerm)}*&type=product&options[fields]=title,vendor,product_type,variants.title,variants.sku,tag,author,body&view=predictive`);

        if (!this.isOpen) return;

        if (!response.ok) throw new Error('Search error');

        const text = await response.text();
        
        // ВАЖНО: Мы ожидаем, что создадим альтернативный шаблон для этого
        this.resultsContainer.innerHTML = text;
        this.open();

        document.querySelector('quick-cart-drawer')?.initTriggers();
      } catch (error) {
        console.error(error);
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.input.value = '';
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
}